import { render, staticRenderFns } from "./MainInstagram.vue?vue&type=template&id=75d12476&"
import script from "./MainInstagram.vue?vue&type=script&lang=js&"
export * from "./MainInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports